import { render, staticRenderFns } from "./form_konteyner_polimernyy_request_trays.vue?vue&type=template&id=0f4e96c4&"
import script from "./form_konteyner_polimernyy_request_trays.vue?vue&type=script&lang=js&"
export * from "./form_konteyner_polimernyy_request_trays.vue?vue&type=script&lang=js&"
import style0 from "./form_konteyner_polimernyy_request_trays.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCardText,VCheckbox,VDialog,VForm,VSelect,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f4e96c4')) {
      api.createRecord('0f4e96c4', component.options)
    } else {
      api.reload('0f4e96c4', component.options)
    }
    module.hot.accept("./form_konteyner_polimernyy_request_trays.vue?vue&type=template&id=0f4e96c4&", function () {
      api.rerender('0f4e96c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/forms_konteyner_polimernyy/form_konteyner_polimernyy_request_trays.vue"
export default component.exports